import app from 'Cloud/Application/app';
import { store } from 'reactApp/store';

const { updateUser } = require('./user.thunkActions');

export const waitForUserUpdate = () => store.dispatch(updateUser()).then(() => app.user.updateUserData());
